/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserResponse } from './RevisdomAPIViewModelsUserResponse';
import {
    RevisdomAPIViewModelsUserResponseFromJSON,
    RevisdomAPIViewModelsUserResponseFromJSONTyped,
    RevisdomAPIViewModelsUserResponseToJSON,
    RevisdomAPIViewModelsUserResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserResponse';
import type { RevisdomAPIViewModelsEntryCommentResponse } from './RevisdomAPIViewModelsEntryCommentResponse';
import {
    RevisdomAPIViewModelsEntryCommentResponseFromJSON,
    RevisdomAPIViewModelsEntryCommentResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryCommentResponseToJSON,
    RevisdomAPIViewModelsEntryCommentResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryCommentResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryVersionResponse
 */
export interface RevisdomAPIViewModelsEntryVersionResponse {
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    fileUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    projectName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    fileName?: string | null;
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsEntryCommentResponse>}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    comments?: Array<RevisdomAPIViewModelsEntryCommentResponse> | null;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    projectId?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    status?: RevisdomAPIViewModelsEntryVersionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    entryType?: RevisdomAPIViewModelsEntryVersionResponseEntryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    thumbnailUrl?: string | null;
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsUserResponse>}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    share?: Array<RevisdomAPIViewModelsUserResponse> | null;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryVersionResponse
     */
    updatedAt?: Date | null;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsEntryVersionResponseStatusEnum = {
    NeedsReview: 'NeedsReview',
    Updated: 'Updated',
    Approved: 'Approved'
} as const;
export type RevisdomAPIViewModelsEntryVersionResponseStatusEnum = typeof RevisdomAPIViewModelsEntryVersionResponseStatusEnum[keyof typeof RevisdomAPIViewModelsEntryVersionResponseStatusEnum];

/**
 * @export
 */
export const RevisdomAPIViewModelsEntryVersionResponseEntryTypeEnum = {
    Project: 'Project',
    Folder: 'Folder',
    File: 'File',
    Version: 'Version'
} as const;
export type RevisdomAPIViewModelsEntryVersionResponseEntryTypeEnum = typeof RevisdomAPIViewModelsEntryVersionResponseEntryTypeEnum[keyof typeof RevisdomAPIViewModelsEntryVersionResponseEntryTypeEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryVersionResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryVersionResponse(value: object): value is RevisdomAPIViewModelsEntryVersionResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryVersionResponseFromJSON(json: any): RevisdomAPIViewModelsEntryVersionResponse {
    return RevisdomAPIViewModelsEntryVersionResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryVersionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryVersionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'projectName': json['projectName'] == null ? undefined : json['projectName'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(RevisdomAPIViewModelsEntryCommentResponseFromJSON)),
        'id': json['id'] == null ? undefined : json['id'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'name': json['name'] == null ? undefined : json['name'],
        'path': json['path'] == null ? undefined : json['path'],
        'status': json['status'] == null ? undefined : json['status'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'share': json['share'] == null ? undefined : ((json['share'] as Array<any>).map(RevisdomAPIViewModelsUserResponseFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function RevisdomAPIViewModelsEntryVersionResponseToJSON(json: any): RevisdomAPIViewModelsEntryVersionResponse {
    return RevisdomAPIViewModelsEntryVersionResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryVersionResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryVersionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileUrl': value['fileUrl'],
        'projectName': value['projectName'],
        'fileName': value['fileName'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(RevisdomAPIViewModelsEntryCommentResponseToJSON)),
        'id': value['id'],
        'projectId': value['projectId'],
        'name': value['name'],
        'path': value['path'],
        'status': value['status'],
        'entryType': value['entryType'],
        'thumbnailUrl': value['thumbnailUrl'],
        'share': value['share'] == null ? undefined : ((value['share'] as Array<any>).map(RevisdomAPIViewModelsUserResponseToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
    };
}

